import type { NavGroup } from "./eventNavConfig";

/**
 * Drop nav items whose `requiredPermission` codename is not held by the
 * current user. Groups that end up empty are removed too.
 *
 * Items without `requiredPermission` are always kept.
 */
export function filterNavGroups(
  groups: NavGroup[],
  userCodenames: string[],
): NavGroup[] {
  const granted = new Set(userCodenames);
  return groups
    .map((group) => ({
      ...group,
      items: group.items.filter(
        (item) =>
          !item.requiredPermission || granted.has(item.requiredPermission),
      ),
    }))
    .filter((group) => group.items.length > 0);
}
